function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `${name}=${value}; path=/; Secure; SameSite=Lax;${expires}`;
  console.log("Postscript cookie created:", name);
}

document.addEventListener("DOMContentLoaded", function() {
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value}; path=/; Secure; SameSite=Lax;${expires}`;
    console.log("Postscript cookie created:", name);
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';').map(c => c.trim());
    return cookies.find(c => c.startsWith(nameEQ))?.substring(nameEQ.length) || null;
  }

  const enterGiveAway = document.getElementById("ele_8BeEOHBqV02");

  document.addEventListener('click', function(event) {
    if (event.target.id === 'ele_8BeEOHBqV02') {
      // document.cookie = "myCookieName=myCookieValue; path=/; max-age=86400"; // expires in 1 day
      alert("Button clicked");
      console.log('Button clicked');
    }
  });


  // getCookie("Promo-500");
});
